import React, { useState } from 'react';
import axios from '../../../../axiosConfig';
import { fetchEarningsTitles } from '../../../../services/earningsApi';
import SummaryDisplay from '../../MicroProbe//Companies/SummaryDisplayNews';

const SignalsBacktestAI = ({ companyData }) => {
    const [predictionResults, setPredictionResults] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchPredictionResults = async (mostRecentTitleId) => {
        try {
            const response = await axios.get('/ai_signal_reasoning/', {
                params: { 
                    transcript_id: mostRecentTitleId,
                    companyName: companyData.name, 
                    symbol: companyData.symbol
                }
            });

            let data = response.data.response;
            if (typeof data === 'string') {
                data = [data];
            }
            setPredictionResults(data);
        } catch (err) {
            setError(err.message);
        }
    };

    const handlePredictionClick = async () => {
        setPredictionResults(null);
        setError(null);
        setLoading(true);

        try {
            const titlesData = await fetchEarningsTitles(companyData.symbol);
            if (titlesData) {
                const { latest_quarter, last_quarter } = titlesData;
                if (last_quarter === null && latest_quarter) {
                    await fetchPredictionResults(latest_quarter);
                } else {
                    setError("No suitable transcript found.");
                }
            } else {
                setError("Failed to fetch title data.");
            }
        } catch (err) {
            setError(err.message);
        }

        setLoading(false);
    };

    return (
      <div>
          <h3>Event-Driven</h3>

          <button onClick={handlePredictionClick} disabled={loading}>
              Analyze
          </button>
          {loading && <div>Thinking, please wait …</div>}
          {predictionResults && <SummaryDisplay summary={predictionResults} />}
          {error && <div>Error: {error}</div>}
      </div>
    );
};

export default SignalsBacktestAI;
